import styled from '@emotion/styled';
import { Text } from 'components/text/Text';
import { Avatar } from 'components/avatar/Avatar';
import { AvatarProps } from 'components/avatar/types';

export type TwoLineCellProps = {
  text?: string;
  color?: string;
  avatarSize?: AvatarProps['size'];
  src?: string;
};

export const AvatarCell = ({ text, color, avatarSize = 'xs', src }: TwoLineCellProps) => {
  const showAvatar: boolean = !!(src || text);
  return (
    <Cell>
      {showAvatar && (
        <Avatar
          size={avatarSize}
          letters={text}
          color={color ? (color.startsWith('#') ? color : `#${color}`) : ''}
          src={src ? src : ''}
        />
      )}
      <AvatarText data-testid="text" variant="bodyXs" weight="regular" color="secondary">
        {text}
      </AvatarText>
    </Cell>
  );
};

const AvatarText = styled(Text)<{ c?: string }>`
  ${p => (p.c ? `color: ${p.c}` : '')}
`;

const Cell = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
